import React from 'react';
import { ExamMetrics } from './exams-metrics';
import { DashboardContent } from '@/layouts/dashboard';

export function ExamMetricsList() {
  return (
    <DashboardContent variant="plain">
      <ExamMetrics />
    </DashboardContent>
  );
}
